import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { StepsStyleConfig as Steps } from "chakra-ui-steps";
import StepsProvider from "components/Steps/provider";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import store from "./store/store";

const theme = extendTheme({
  components: {
    Steps,
  },
});

try {
  Sentry.init({
    dsn: `${process.env.REACT_APP_SENTRY_DSN}`,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_NODE_ENV,
  });
} catch (err) {}

const isProd = process.env.NODE_ENV === "production";
const isDev = String(process.env.NODE_ENV).toLowerCase().includes("dev");
// so many logs, use this to single out a particular log
console.relog = () => {};
if (process.env.REACT_APP_ENABLE_RELOGS === "true") {
  console.relog = console.log;
}

isProd && (console.log = () => {});
// and this to disable those swarms of headaches
process.env.REACT_APP_DISABLE_LOGS === "true" && (console.log = () => {});

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider resetCSS theme={theme}>
      <StepsProvider maxStep={3}>
        <Provider store={store}>          
          <App />
        </Provider>
      </StepsProvider>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// not in use, we place the subscription in components/ProtectedRoutes to capture signed up users
if (isDev)
  serviceWorker.register({
    useCache: false,
    useWebPush: false,
    onlyOurOrigin: false,
  });
